import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const backButtonStyles: SxProps<Theme> = {
    mb: 2,
};

export const headerBoxStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'flex-start', sm: 'center' },
    justifyContent: 'space-between',
    gap: 2,
    mb: 4,
};

/**
 * The patient's face beside their name, at the top of their own page.
 *
 * `lg` rather than `md`, which is the one place in the app outside the profile card that
 * warrants it: this heading is the answer to "whose page am I on", and it is read once on
 * arrival rather than scanned down a column.
 */
export const titleRowStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    mb: 1,
};

export const titleStyles: SxProps<Theme> = {
    fontWeight: 700,
    letterSpacing: '-0.015em',
};

export const subtitleStyles: SxProps<Theme> = {
    color: 'text.secondary',
};

/**
 * The contact details under the name. They wrap rather than truncate: a phone number cut
 * off mid-way is worse than one on its own line.
 */
export const identityRowStyles: SxProps<Theme> = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 2,
    mt: 1,
};

export const identifierStyles: SxProps<Theme> = {
    fontFamily: 'monospace',
    fontSize: '0.85rem',
    color: 'text.secondary',
};

export const alertStyles: SxProps<Theme> = {
    mb: 3,
    borderRadius: 3,
};

export const loadingBoxStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    py: 8,
};

export const sectionStyles: SxProps<Theme> = {
    mb: 5,
};

export const sectionHeaderStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'flex-start', sm: 'center' },
    justifyContent: 'space-between',
    gap: 2,
    mb: 2,
};

/**
 * The buttons at the end of a section's header, when there is more than one. They wrap
 * rather than squeeze: two Romanian labels do not fit beside each other on a phone.
 */
export const sectionHeaderActionsStyles: SxProps<Theme> = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
};

export const sectionTitleStyles: SxProps<Theme> = {
    fontWeight: 700,
};

export const tabsStyles: SxProps<Theme> = {
    borderBottom: '1px solid rgba(16,24,40,0.08)',
    mb: 3,
};

export const cardListStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
};

export const emptyStateBoxStyles: SxProps<Theme> = {
    textAlign: 'center',
    py: 6,
};

export const emptyStateIconStyles = (theme: Theme): SxProps<Theme> => ({
    fontSize: 64,
    color: theme.palette.grey[300],
    mb: 2,
});
